/* eslint-disable @typescript-eslint/ban-ts-comment */
import PropTypes from 'prop-types';
import { FormikSelect } from '@febos-io/design';

import { useTranslation } from '../../../hooks';
import { InputProps } from "./types";

export function FilterSelect({
  name,
  config,
  isMulti = false
}:InputProps) {
  const { t } = useTranslation();

  return (
    <FormikSelect
      name={name}
      // @ts-ignore
      options={config.options}
      label={`${t(config.name)}`}
      placeholder={`${t(config.name)}`}
      isModal
      isMulti={isMulti}
    />
  );
}

FilterSelect.propTypes = {
  name: PropTypes.string,
  isMulti: PropTypes.bool,
  config: PropTypes.object
};

export default FilterSelect;
